import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query';

import { type CommonQueryArgs, DAAS_ACTIVE_LISTINGS, useQueryDisabled } from '@pkg/hooks';

import { type ListingQueryParams, type SupportedTokens, type UnifiedCollectionFormat } from '@app/client';
import { callGetActiveListingData } from '@app/client/resources/daas';

interface GetListingCountsArgs extends CommonQueryArgs, ListingQueryParams {
    slugQuery: UnifiedCollectionFormat;
    chain: SupportedTokens;
}
export function useGetActiveListingCounts({ slugQuery, chain, disabled, count_only = true }: GetListingCountsArgs) {
    const queryClient = useQueryClient();
    const cache = [DAAS_ACTIVE_LISTINGS, slugQuery, 'count', count_only];
    const hasQueryData = cache && queryClient.getQueryData(cache);
    const queryDisabled = useQueryDisabled([!hasQueryData, !disabled, slugQuery?.length, chain]);
    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetActiveListingData({
                settings: { signal },
                query: {
                    slugs: slugQuery,
                    count_only: count_only,
                },
            }),
        retry: false,
        enabled: !queryDisabled,
        placeholderData: keepPreviousData,
        select: (res) => {
            if (res?.ok && res?.value && chain) {
                return res.value[chain];
            }
        },
    });
}
